import {
  faFileAlt,
  faFileContract,
  faUsers,
  faFolder,
} from '@fortawesome/free-solid-svg-icons';

export const MENU_ITEMS = [
  { icon: faFileAlt, text: 'Company Snapshot', tab: 'company-snapshot', public: true },
  { icon: faFileContract, text: 'Deal Terms', tab: 'deal-terms', public: false },
  { icon: faUsers, text: 'Team', tab: 'team', public: false },
  { icon: faFolder, text: 'Vault', tab: 'data-room', public: false },
];
